import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  onlyNumberLess100,
  onlyNumberSharing,
} from "../../CommonMethhods/CommonMethods";

function SlabWise(props) {
  const brokerageApi = props?.brokerageApi;
  const brokerageModules =
    brokerageApi?.modules !== undefined || null ? brokerageApi?.modules : "";

  const [middleModule, setMiddleModule] = useState(false);
  const [reRender, setReRender] = useState(false);

  let slabWiseSchema = Yup.object().shape({
    slabwiseFrom: Yup.string().required(),
    slabwiseTo: Yup.string().required(),
    slabwiseSharing: Yup.string().required(),
  });
  let slabWiseLongSchema = Yup.object().shape({
    slabWishSharing: Yup.string().required(),
    slabwiseFrom: Yup.string().required(),
    slabwiseTo: Yup.string().required(),
    slabWishTrade: Yup.string().required(),
    slabWishDel: Yup.string().required(),
    slabWishFuture: Yup.string().required(),
    slabWishNifty: Yup.string().required(),
    slabWishBankNifty: Yup.string().required(),
    slabWishOptionStock: Yup.string().required(),
  });
  const {
    formState: slabWiseState,
    register: slabWiseRegister,
    reset: slabWiseReset,
    getValues: slabWiseGetValue,
  } = useForm({
    resolver: yupResolver(slabWiseSchema),
    mode: "onChange",
  });
  const {
    formState: slabWiseLongState,
    register: slabWiseLongRegister,
    reset: slabWiseLongReset,
    getValues: slabWiseLongGetValue,
  } = useForm({
    resolver: yupResolver(slabWiseLongSchema),
    mode: "onChange",
  });
  // const [slabWiseModuleCount, setSlabWiseModuleCount] = useState(0);

  const updateCount = (data, i) => {
    // slabWiseReset();
    console.log(data, "data");
    console.log(i, "I");

    if (i === 1) {
      setMiddleModule(true);
      slabWiseLongReset();
      if (props?.updateData?.brokerage) {
        if (
          props?.updateData?.brokerage?.bid === 2 &&
          i === props?.updateData?.brokerage?.modules?.id - 1
        ) {
          slabWiseReset({
            slabwiseFrom:
              props?.updateData?.brokerage?.modules?.from?.toString(),
            slabwiseTo: props?.updateData?.brokerage?.modules?.to?.toString(),
            slabwiseSharing:
              props?.updateData?.brokerage?.modules?.sharing?.toString(),
          });
        } else {
          slabWiseReset({
            slabwiseFrom: data?.from?.toString(),
            slabwiseTo: data?.to?.toString(),
            slabwiseSharing: data?.sharing?.toString(),
          });
        }
      } else {
        slabWiseReset({
          slabwiseFrom: data?.from?.toString(),
          slabwiseTo: data?.to?.toString(),
          slabwiseSharing: data?.sharing?.toString(),
        });
      }
    } else {
      setMiddleModule(false);
      slabWiseReset();
      if (props?.updateData?.brokerage) {
        if (
          props?.updateData?.brokerage?.bid === 2 &&
          i === props?.updateData?.brokerage?.modules?.id - 1
        ) {
          slabWiseLongReset({
            slabWishSharing:
              props?.updateData?.brokerage?.modules?.sharing?.toString(),
            slabwiseFrom:
              props?.updateData?.brokerage?.modules?.from?.toString(),
            slabwiseTo: props?.updateData?.brokerage?.modules?.to?.toString(),
            slabWishTrade:
              props?.updateData?.brokerage?.modules?.trade?.toString(),
            slabWishDel: props?.updateData?.brokerage?.modules?.del?.toString(),
            slabWishFuture:
              props?.updateData?.brokerage?.modules?.future?.toString(),
            slabWishNifty:
              props?.updateData?.brokerage?.modules?.nifty?.toString(),
            slabWishBankNifty:
              props?.updateData?.brokerage?.modules?.bankNifty?.toString(),
            slabWishOptionStock:
              props?.updateData?.brokerage?.modules?.optionStock?.toString(),
          });
        } else {
          slabWiseLongReset({
            slabWishSharing: data?.sharing?.toString(),
            slabwiseFrom: data?.from?.toString(),
            slabwiseTo: data?.to?.toString(),
            slabWishTrade: data?.trade?.toString(),
            slabWishDel: data?.del?.toString(),
            slabWishFuture: data?.future?.toString(),
            slabWishNifty: data?.nifty?.toString(),
            slabWishBankNifty: data?.bankNifty?.toString(),
            slabWishOptionStock: data?.optionStock?.toString(),
          });
        }
      } else {
        console?.log(slabWiseLongGetValue(), "sdfgvoiu");
        slabWiseLongReset({
          slabWishSharing: data?.sharing?.toString(),
          slabwiseFrom: data?.from?.toString(),
          slabwiseTo: data?.to?.toString(),
          slabWishTrade: data?.trade?.toString(),
          slabWishDel: data?.del?.toString(),
          slabWishFuture: data?.future?.toString(),
          slabWishNifty: data?.nifty?.toString(),
          slabWishBankNifty: data?.bankNifty?.toString(),
          slabWishOptionStock: data?.optionStock?.toString(),
        });
      }
    }
  };

  const manageSlabWiseData = () => {
    let AllModuleInput = document.querySelectorAll(".slab-module");
    let CheckedArray = Array.from(AllModuleInput).filter(
      (item) => item.checked === true
    );
    let ModuleID = CheckedArray[0]?.value;

    console.log(slabWiseState?.isValid);

    if (ModuleID == "2") {
      if (slabWiseState?.isValid) {
        console.log(ModuleID, "ModuleID");
        return {
          ...slabWiseGetValue(),
          id: ModuleID,
        };
      }
    } else {
      if (slabWiseLongState.isValid) {
        return {
          ...slabWiseLongGetValue(),
          id: ModuleID,
        };
      }
    }
  };

  const manageSlabWise = () => {
    if (slabWiseLongState.isValid) {
      let AllModuleInput = document.querySelectorAll(".slab-module");
      let CheckedArray = Array.from(AllModuleInput).filter(
        (item) => item.checked === true
      );
      let SlabModuleID = CheckedArray[0]?.value;
      return {
        ...slabWiseGetValue(),
        id: SlabModuleID,
      };
    }
  };
  props.biRef.manageSlabWise = manageSlabWise;
  props.biRef.manageSlabWiseData = manageSlabWiseData;
  const defaultShow = () => {
    let AllModuleInput = document.querySelectorAll(".slab-module");

    if (props?.updateData?.brokerage) {
      if (props?.updateData?.brokerage?.bid === 2) {
        AllModuleInput[props?.updateData?.brokerage?.modules?.id - 1]?.click();
      } else {
        AllModuleInput[0]?.click();
      }
    } else {
      // console?.log("svdygsildu");
      AllModuleInput[0]?.click();
    }
  };
  useEffect(() => {
    defaultShow();
  }, []);
  return (
    <>
      <div className="module-main">
        {brokerageModules &&
          brokerageModules.map((item, key) => {
            // console.log(item, "key");
            return (
              <div className="radio-module" key={key}>
                <input
                  type="radio"
                  className="slab-module"
                  name="slab-module"
                  defaultValue={item?.id}
                  onClick={() => updateCount(item, key)}
                />

                <label>{item?.mname}</label>
              </div>
            );
          })}
      </div>

      {middleModule ? (
        <form className="ap_master_table slabTable scroll-table">
          <table className="table ">
            <thead>
              <tr>
                <th scope="col">From (In Lakhs)</th>
                <th scope="col">To (In Lakhs)</th>
                <th scope="col">Sharing</th>
              </tr>
            </thead>
            <tbody>
              <>
                <tr>
                  <td>
                    <input
                      id="slab-input1"
                      className="td-input"
                      type="number"
                      autocomplete="off"
                      onInput={(e) => {
                        onlyNumberLess100(e);
                      }}
                      {...slabWiseRegister(`slabwiseFrom`)}
                    />
                  </td>
                  <td>
                    <input
                      id="slab-input2"
                      className="td-input"
                      autocomplete="off"
                      type="number"
                      onInput={(e) => {
                        onlyNumberSharing(e);
                      }}
                      {...slabWiseRegister(`slabwiseTo`)}
                    />
                  </td>
                  <td>
                    <input
                      id="slab-input3"
                      className="td-input"
                      autocomplete="off"
                      type="number"
                      onInput={(e) => {
                        onlyNumberSharing(e);
                      }}
                      {...slabWiseRegister(`slabwiseSharing`)}
                    />
                  </td>
                </tr>
              </>
            </tbody>
          </table>
        </form>
      ) : (
        <form className="ap_master_table  scroll-table">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Sharing</th>
                <th scope="col">From (In Lakhs)</th>
                <th scope="col">To (In Lakhs)</th>
                <th scope="col">Trade</th>
                <th scope="col">Del</th>
                <th scope="col">Future</th>
                <th scope="col">Nifty</th>
                <th scope="col">Bank Nifty</th>
                <th scope="col">Option Stock</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    className="td-input"
                    id="mtf-input1"
                    type="number"
                    autocomplete="off"
                    onInput={(e) => {
                      onlyNumberSharing(e);
                    }}
                    {...slabWiseLongRegister(`slabWishSharing`)}
                  />
                </td>
                <td>
                  <input
                    id="mtf-input2"
                    className="td-input"
                    type="number"
                    autocomplete="off"
                    onInput={(e) => {
                      onlyNumberLess100(e);
                    }}
                    {...slabWiseLongRegister(`slabwiseFrom`)}
                  />
                </td>
                <td>
                  <input
                    id="mtf-input3"
                    className="td-input"
                    autocomplete="off"
                    type="number"
                    onInput={(e) => {
                      onlyNumberSharing(e);
                    }}
                    {...slabWiseLongRegister(`slabwiseTo`)}
                  />
                </td>
                <td>
                  <input
                    className="td-input"
                    id="mtf-input4"
                    type="number"
                    autocomplete="off"
                    onInput={(e) => {
                      onlyNumberLess100(e);
                    }}
                    {...slabWiseLongRegister(`slabWishTrade`)}
                  />
                </td>
                <td>
                  <input
                    className="td-input"
                    id="mtf-input5"
                    type="number"
                    autocomplete="off"
                    onInput={(e) => {
                      onlyNumberLess100(e);
                    }}
                    {...slabWiseLongRegister(`slabWishDel`)}
                  />
                </td>
                <td>
                  <input
                    className="td-input"
                    id="mtf-input6"
                    type="number"
                    autocomplete="off"
                    onInput={(e) => {
                      onlyNumberLess100(e);
                    }}
                    {...slabWiseLongRegister(`slabWishFuture`)}
                  />
                </td>
                <td>
                  <input
                    className="td-input"
                    id="mtf-input7"
                    type="number"
                    autocomplete="off"
                    onInput={(e) => {
                      onlyNumberLess100(e);
                    }}
                    {...slabWiseLongRegister(`slabWishNifty`)}
                  />
                </td>
                <td>
                  <input
                    className="td-input"
                    id="mtf-input8"
                    type="number"
                    autocomplete="off"
                    onInput={(e) => {
                      onlyNumberLess100(e);
                    }}
                    {...slabWiseLongRegister(`slabWishBankNifty`)}
                  />
                </td>
                <td>
                  <input
                    className="td-input"
                    id="mtf-input9"
                    type="number"
                    autocomplete="off"
                    onInput={(e) => {
                      onlyNumberLess100(e);
                    }}
                    {...slabWiseLongRegister(`slabWishOptionStock`)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      )}

      <span className="field-error">
        {middleModule
          ? !slabWiseState.isValid && <>Field required *</>
          : !slabWiseLongState.isValid && <>Field required *</>}
      </span>
    </>
  );
}

export default SlabWise;
